import React, { Component } from 'react'
import leftIcon from '../../../../../assets/icons/arrow-left.png'
import rightIcon from '../../../../../assets/icons/arrow-right.png'
import './styles.sass'

interface State {
  slides: any[],
  currentSlide: any,
  sliderWidth: any,
  sliderHeight: any,
  sliderInterval: any,
  sliderRef: any
};

export class ItemSlider extends Component<{ passedSlides: any[] }> {
  state: State = {
    slides: [],
    currentSlide: 1,
    sliderWidth: 0,
    sliderHeight: 0,
    sliderInterval: null,
    sliderRef: null
  }
  sliderRef = React.createRef<any>()

  componentDidMount() {
    if(!this.sliderRef.current) return;

    const sliderWidth = (this.sliderRef.current as HTMLElement).offsetWidth;

    const slidesCopy = this.props.passedSlides.map((x, index) => ({
      image: x
    }));
  
    const firstSlide = [...slidesCopy].shift();
    const lastSlide = [...slidesCopy].pop();

    const slides = [
      lastSlide,
      ...slidesCopy,
      firstSlide
    ].map((x, index) => ({
      ...x,
      left: sliderWidth * index
    }));

    this.setState({
      ...this.state,
      sliderWidth,
      slides
    });

    // Calcular altura baseada na primeira imagem
    this.calculateSliderHeight();

    // Adicionar listener para redimensionamento
    window.addEventListener('resize', this.handleResize);

    setTimeout(() => {
      const slidesCopy = slides.map(x => {

        x.left = x.left - sliderWidth;

        return x;
      });

      this.setState({
        ...this.state,
        slidesCopy
      });
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    if (this.sliderRef.current) {
      const newWidth = (this.sliderRef.current as HTMLElement).offsetWidth;
      this.setState({
        ...this.state,
        sliderWidth: newWidth
      }, () => {
        this.calculateSliderHeight();
      });
    }
  }

  calculateSliderHeight = () => {
    if (this.props.passedSlides.length > 0) {
      const img = new Image();
      img.onload = () => {
        // Calcular aspect ratio real do banner carregado
        const actualAspectRatio = img.height / img.width;
        const containerWidth = this.state.sliderWidth;
        
        // Calcular altura baseada no aspect ratio real do banner
        const imageHeight = containerWidth * actualAspectRatio;
        
        // Definir altura mínima e máxima
        const minHeight = 300; // altura mínima em px
        const maxHeight = Math.min(window.innerHeight * 0.8, 800); // máximo de 80% da tela ou 800px
        
        // A altura do container deve ser exatamente a altura calculada
        let finalHeight = Math.max(minHeight, Math.min(imageHeight, maxHeight));
        
        this.setState({
          ...this.state,
          sliderHeight: finalHeight
        });
      };
      img.onerror = () => {
        // Fallback se a imagem não carregar - usar aspect ratio padrão
        const defaultAspectRatio = 428 / 1600; // 0.2675
        const fallbackHeight = this.state.sliderWidth * defaultAspectRatio;
        this.setState({
          ...this.state,
          sliderHeight: Math.max(300, fallbackHeight)
        });
      };
      img.src = this.props.passedSlides[0];
    }
  }

  onBtnClick(orientation: string) {
    const slidesCopy = this.state.slides.map(x => {

      x.left = orientation === 'next' ? x.left - this.state.sliderWidth : x.left + this.state.sliderWidth;

      return x;
    });

    this.setState({
      ...this.state,
      slidesCopy,
      currentSlide: orientation === 'next' ? this.state.currentSlide + 1 : this.state.currentSlide - 1
    });
  }

  jumpToPosition(currentSlide: number) {
    this.state.slides.map((x, index) => {

      x.left = (this.state.sliderWidth * index) - (this.state.sliderWidth * currentSlide);

      return x;
    });

    this.setState({
      ...this.state,
      currentSlide
    });
  }

  render() {
    const containerStyle = {
      height: this.state.sliderHeight > 0 ? `${this.state.sliderHeight}px` : '300px'
    };

    return (
      <div className='slider-container'>
        <div ref={this.sliderRef} className='item-slider-container noselect' style={containerStyle}>
          {this.state.slides.length > 1 &&
          <>
            {this.state.currentSlide > 1 &&
            <button className='previous jump-btn' onClick={() => this.onBtnClick('before')}>
              <img src={leftIcon} />
            </button>}
            {this.state.currentSlide < this.props.passedSlides.length &&
              <button className='next jump-btn' onClick={() => this.onBtnClick('next')}>
              <img src={rightIcon} />
            </button>}
          </>}
          <div className='slides'>
            {
              this.state.slides.map((slide, index) => 
                <div key={'item_slide_'+index} className='slide' style={{width: this.state.sliderWidth, left: slide.left}}>
                  <img className='background' src={slide.image} />
                </div>  
              )
            }
          </div>
          {/* {this.props.passedSlides.length > 1 &&
          <div className='slide-dots'>
            {
              Array.from(Array(this.props.passedSlides.length).keys()).map(i => 
                <div key={'item_dot_'+i} className={'dot '+ (this.state.currentSlide === i+1 ? 'selected' : '')} onClick={() => this.jumpToPosition(i+1)}></div>
              )
            }
          </div>} */}
        </div>
      </div>
    )
  }
}